import { render, staticRenderFns } from "./DefaultForm.vue?vue&type=template&id=2486197d&"
import script from "./DefaultForm.vue?vue&type=script&lang=js&"
export * from "./DefaultForm.vue?vue&type=script&lang=js&"
import style0 from "./DefaultForm.vue?vue&type=style&index=0&id=2486197d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports